<template>
  <div id="analisar-dados-formulario">
    <div class="row align-items-end">
      <div class="col-md-4">
        <div class="form-group">
          <label for="tipo-analise">Tipo de avaliação</label>
          <vue-select
            v-model="tipoAnalise"
            :options="tiposAnalise"
            label="label"
            placeholder="Digite para pesquisar..."
            @input="onTipoAnaliseChange"
            class="vue-select"
          >
            <div slot="no-options">Não há opções correspondentes</div>
          </vue-select>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group form-group-periodo">
          <label>Período da avaliação</label>
          <date-range-picker
            ref="picker"
            :opens="'right'"
            :locale-data="localeData"
            :minDate="minDate"
            :maxDate="maxDate"
            :autoApply="true"
            :ranges="ranges"
            v-model="dateRange"
            @update="onDateRangeChange"
          >
            <template v-slot:input="picker" style="min-width: 350px">
              {{ formatDate(picker.startDate) }} -
              {{ formatDate(picker.endDate) }}
            </template>
          </date-range-picker>
        </div>
      </div>
      <div class="col-md-1 d-flex align-items-center justify-content-center">
        <button
          id="botao-limpar-filtros"
          class="btn btn-outline-secondary btn-sem-bg"
          @click="limparFiltrosDeData"
        >
          <i class="icofont-ui-delete icone-cinza-escuro"></i>
        </button>
      </div>
      <!-- Chat removido -->
    </div>
    <div class="mt-4">
      <tabela-avaliacao-treinamento
        :cadastros="dadosFiltrados"
        :loading="loading"
        :tipoAnalise="tipoAnaliseReal"
      ></tabela-avaliacao-treinamento>
    </div>

    <!-- Modal de chat removido -->
  </div>
</template>

<script>
import vueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { api } from '@/plugins/axios'
import SectionTitle from '@/components/SectionTitle'
import TabelaAvaliacaoTreinamento from './TabelaAvaliacaoTreinamento.vue'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
  components: {
    'vue-select': vueSelect,
    SectionTitle,
    TabelaAvaliacaoTreinamento,
    DateRangePicker,
  },
  data() {
    return {
      tipoAnalise: { label: 'COMENTÁRIOS' },
      tiposAnalise: [
        { label: 'SUS Digital' },
        { label: 'COMENTÁRIOS' },
        { label: 'TEMAS SUGERIDOS' },
      ],
      dateRange: {
        startDate: this.getQuadrimestrePassadoStartDate(),
        endDate: new Date(),
      },
      localeData: {
        direction: 'ltr',
        format: 'DD/MM/YYYY',
        separator: ' - ',
        applyLabel: 'Aplicar',
        cancelLabel: 'Cancelar',
        weekLabel: 'S',
        customRangeLabel: 'Intervalo personalizado',
        daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: [
          'Jan',
          'Fev',
          'Mar',
          'Abr',
          'Mai',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Out',
          'Nov',
          'Dez',
        ],
        firstDay: 0,
      },
      ranges: {
        'Esta semana': [
          new Date(
            new Date().setDate(new Date().getDate() - new Date().getDay())
          ),
          new Date(),
        ],
        'Semana passada': [
          new Date(
            new Date().setDate(new Date().getDate() - new Date().getDay() - 7)
          ),
          new Date(
            new Date().setDate(new Date().getDate() - new Date().getDay() - 1)
          ),
        ],
        'Este mês': [
          new Date(new Date().getFullYear(), new Date().getMonth(), 1),
          new Date(),
        ],
        'Mês passado': [
          new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
          new Date(new Date().getFullYear(), new Date().getMonth(), 0),
        ],
        'Este quadrimestre': [
          new Date(
            new Date().getFullYear(),
            Math.floor(new Date().getMonth() / 4) * 4,
            1
          ),
          new Date(),
        ],
        'Quadrimestre passado': [
          this.getQuadrimestrePassadoStartDate(),
          new Date(
            new Date().getFullYear(),
            Math.floor(new Date().getMonth() / 4) * 4,
            0
          ),
        ],
      },
      minDate: null,
      maxDate: new Date().toISOString().substr(0, 10),
      equipe: null,
      equipes: [],
      dadosAnalisados: [],
      dadosFiltrados: [],
      loading: false,
      modalChat: false,
      dataFiltrada: false,
      messages: [
        { text: 'Bem-vindo ao bate-papo! Como posso ajudar?' },
        { text: 'Quais são os horários de funcionamento?' },
      ],
      newMessage: '',
    }
  },
  computed: {
    tipoAnaliseReal() {
      if (this.tipoAnalise.label === 'COMENTÁRIOS') {
        return { label: 'AVALIAÇÃO DOS PARTICIPANTES' }
      }
      return this.tipoAnalise
    },
    descricaoTitulo() {
      switch (this.tipoAnalise?.label) {
        case 'SUS Digital':
          return 'Opinião sobre o SUS Digital'
        case 'COMENTÁRIOS':
          return 'Avaliação dos Participantes'
        case 'TEMAS SUGERIDOS':
          return 'Temas Sugeridos'
        default:
          return 'Descrição'
      }
    },
    dateRangeText() {
      if (this.dateRange.startDate && this.dateRange.endDate) {
        return `${this.formatDate(
          this.dateRange.startDate
        )} - ${this.formatDate(this.dateRange.endDate)}`
      }
      return ''
    },
  },
  mounted() {
    const data = this.$store.state.equipesV2
    if (data?.length) {
      this.equipes = data.map((item) => ({
        no_unidade_saude: item.no_unidade_saude,
        nu_cnes: item.nu_cnes,
      }))
      const coIbge = data[0].co_ibge
      this.fetchAvaliacaoTreinamento(coIbge)
    } else {
    }
  },
  methods: {
    /**
     * Calcula a data inicial do quadrimestre anterior.
     *
     * @returns {Date} Primeiro dia do quadrimestre anterior.
     */
    getQuadrimestrePassadoStartDate() {
      const now = new Date()
      const month = now.getMonth()
      const year = now.getFullYear()
      const startMonth = Math.floor((month - 4) / 4) * 4
      return new Date(year, startMonth, 1)
    },

    /**
     * Calcula a data inicial do quadrimestre atual.
     *
     * @returns {Date} Primeiro dia do quadrimestre atual.
     */
    getQuadrimestreAtualStartDate() {
      const now = new Date()
      const month = now.getMonth()
      const year = now.getFullYear()
      const startMonth = Math.floor(month / 4) * 4
      return new Date(year, startMonth, 1)
    },

    /**
     * Atualiza os dados filtrados após a alteração
     * do tipo de avaliação selecionado.
     *
     * @returns {void}
     */
    onTipoAnaliseChange() {
      this.filtrarDados()
    },

    /**
     * Filtra os dados das avaliações pelo período selecionado.
     *
     * Quando não existe um período definido, considera todos
     * os registros disponíveis. Ordena os resultados pela
     * data do treinamento, da mais recente para a mais antiga.
     *
     * @returns {void}
     */
    filtrarDados() {
      const ordenarPorDataDesc = (arr) => {
        const copia = Array.isArray(arr) ? [...arr] : []
        return copia.sort((a, b) => {
          const dtA = a?.dt_treinamento
            ? new Date(a.dt_treinamento).getTime()
            : 0
          const dtB = b?.dt_treinamento
            ? new Date(b.dt_treinamento).getTime()
            : 0
          return dtB - dtA
        })
      }

      if (this.dateRange.startDate && this.dateRange.endDate) {
        const filtrados = this.dadosAnalisados.filter((dado) => {
          const dataTreinamento = new Date(dado.dt_treinamento)
          return (
            dataTreinamento >= new Date(this.dateRange.startDate) &&
            dataTreinamento <= new Date(this.dateRange.endDate)
          )
        })
        this.dadosFiltrados = ordenarPorDataDesc(filtrados)
      } else {
        this.dadosFiltrados = ordenarPorDataDesc(this.dadosAnalisados)
      }
    },

    /**
     * Atualiza o intervalo de datas selecionado e
     * aplica novamente os filtros das avaliações.
     *
     * @param {Object} range Intervalo de datas selecionado.
     * @param {Date|null} range.startDate Data inicial.
     * @param {Date|null} range.endDate Data final.
     * @returns {void}
     */
    onDateRangeChange(range) {
      this.dateRange = range
      this.filtrarDados()
    },

    /**
     * Remove o filtro de período das avaliações.
     *
     * Limpa as datas selecionadas e atualiza
     * a listagem com todos os registros disponíveis.
     *
     * @returns {void}
     */
    limparFiltrosDeData() {
      this.dateRange = { startDate: null, endDate: null }
      this.dataFiltrada = false
      this.filtrarDados()
    },

    /**
     * Obtém a descrição correspondente ao tipo
     * de avaliação selecionado.
     *
     * Considera as avaliações do SUS Digital,
     * os comentários dos participantes e os temas sugeridos.
     *
     * @param {Object} dado Registro da avaliação.
     * @returns {*} Descrição correspondente ou string vazia.
     */
    getDescricao(dado) {
      switch (this.tipoAnaliseReal?.label) {
        case 'SUS Digital':
          return dado.descricao_compreensao_usuario
        case 'AVALIAÇÃO DOS PARTICIPANTES':
          return dado.opiniaoTreinamento
        case 'TEMAS SUGERIDOS':
          return dado.sugestao_tema
        default:
          return ''
      }
    },

    /**
     * Busca os dados das avaliações de treinamento
     * de um município na API.
     *
     * Atualiza os registros disponíveis, aplica os filtros
     * e controla o estado de carregamento da tabela.
     *
     * @param {string|number} coIbge Código IBGE do município.
     * @returns {void}
     */
    fetchAvaliacaoTreinamento(coIbge) {
      this.loading = true
      api
        .get(`/app/avaliacao-treinamento/${coIbge}`)
        .then((response) => {
          if (response.data?.length) {
            this.dadosAnalisados = response.data
            this.filtrarDados()
          }
        })
        .catch((error) => {
          console.error('Error fetching data:', error)
        })
        .finally(() => {
          this.loading = false
        })
    },

    /**
     * Formata uma data para o padrão brasileiro (dd/mm/aaaa).
     *
     * @param {string|Date|null} date Data a ser formatada.
     * @returns {string} Data formatada ou string vazia.
     */
    formatDate(date) {
      if (!date) return ''
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
      return new Date(date).toLocaleDateString('pt-BR', options)
    },

    /**
     * Adiciona uma mensagem à lista do chat.
     *
     * Ignora mensagens vazias e limpa o campo
     * de entrada após adicionar a mensagem.
     *
     * @returns {void}
     */
    sendMessage() {
      if (this.newMessage.trim() !== '') {
        this.messages.push({ text: this.newMessage })
        this.newMessage = ''
      }
    },

    /**
     * Remove uma mensagem da lista do chat.
     *
     * @param {number} index Índice da mensagem a ser removida.
     * @returns {void}
     */
    removeMessage(index) {
      this.messages.splice(index, 1)
    },

    /**
     * Inicia a ação de gravação de áudio.
     *
     * Atualmente apresenta apenas uma mensagem informativa,
     * pois a funcionalidade de gravação ainda não foi implementada.
     *
     * @returns {void}
     */
    startRecording() {
      // Função de gravação a ser implementada
      alert('Gravação iniciada...')
    },
  },
}
</script>

<style lang="scss" scoped>
#analisar-dados-formulario {
  .form-group {
    margin-bottom: 15px;

    &-periodo {
      display: flex;
      flex-direction: column;
    }
  }

  .align-items-end {
    align-items: center !important;
  }
}

#botao-limpar-filtros {
  margin-bottom: -12px;
  margin-left: -180px;
  background-color: transparent;
  border: none;
  box-shadow: 0 0px 0px 0 rgb(0 0 0 / 0%), 0 3px 1px -2px rgba(0, 0, 0, -3.8),
    0 1px 5px 0 rgba(0, 0, 0, -5.88);
  font-size: 20px;

  .icone-cinza-escuro {
    color: #555;
  }

  @media (max-width: 767px) {
    display: none;
  }
}
</style>
